import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import CaseStudiesHero from '../layouts/CaseStudies/CaseStudiesHero'
import FeaturedCaseStudies from '../layouts/CaseStudies/FeaturedCaseStudies'
import SuccessMetrics from '../layouts/CaseStudies/SuccessMetrics'
import CaseStudyShowcase from '../layouts/CaseStudies/CaseStudyShowcase'
import TestimonialsSlider from '../layouts/Home/TestimonialsSection'
import FinalCTA from '../layouts/FinalCTA'

const CaseStudies = () => {
    return (
        <>
            <Header />
            <CaseStudiesHero />
            <FeaturedCaseStudies />
            <SuccessMetrics />
            <CaseStudyShowcase />
            <TestimonialsSlider />
            <FinalCTA/>
            <Footer />
        </>
    )
}

export default CaseStudies